import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import React from "react";
import {AmountHelper} from "src/helpers/AmountHelper";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import {NFPlainText} from "src/components/Shared/NewForms/NFPlainText";
import {NFLookupUnit} from "src/components/Shared/NewForms/NFLookupUnit";
import {NFIntInput} from "src/components/Shared/NewForms/NFIntInput";
import {NFLookupVatType} from "src/components/Shared/NewForms/NFLookupVatType";
import {NFLookupConstructionObject} from "src/components/Shared/NewForms/NFLookupConstructionObject";

export const VendorInvoicesDetailProducts = () => {
    const tableName = "products";
    const { setValue, getValues } = useFormContext();
    const { t } = useTranslation();

    const handleQuantityChanged = (newQuantity: number, index: number) => {
        const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
            newQuantity,
            getValues(`${tableName}.${index}.price`),
            getValues(`${tableName}.${index}.vatType`),
            getValues("priceIncludesVat")
        );
        setValue(`${tableName}.${index}.amount`, newAmounts.amount);
        setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
        setValue(
            `${tableName}.${index}.amountWithVat`,
            newAmounts.amountWithVat
        );
    };

    const handlePriceChanged = (newPrice: number, index: number) => {
        const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
            getValues(`${tableName}.${index}.quantity`),
            newPrice,
            getValues(`${tableName}.${index}.vatType`),
            getValues("priceIncludesVat")
        );
        setValue(`${tableName}.${index}.amount`, newAmounts.amount);
        setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
        setValue(
            `${tableName}.${index}.amountWithVat`,
            newAmounts.amountWithVat
        );
    };

    return (
        <>
            <NFormTable fieldArray={tableName}>
                <NFLookupProduct
                    title={t("Product")}
                    fieldName="productId"
                    width={200}
                    required={true}
                />
                <NFPlainText
                    title={t("vendorCode")}
                    fieldName={"vendorCode"}
                    width={200}
                />
                
                <NFLookupUnit
                    title={t("Unit")}
                    fieldName="unitId"
                    width={200}
                    required={true}
                />
                <NFIntInput
                    fieldName={"quantity"}
                    title={t("Quantity")}
                    onValueChanged={handleQuantityChanged}
                    width={100}
                />
                <NFIntInput
                    fieldName={"price"}
                    title={t("Price")}
                    width={100}
                    onValueChanged={handlePriceChanged}
                />
                <NFIntInput
                    fieldName={"amount"}
                    title={t("Amount")}
                    width={100}
                />
                <NFLookupVatType
                    title={t("vatType")}
                    fieldName={"vatTypeId"}
                    width={150}
                />
                <NFIntInput
                    fieldName={"vatRate"}
                    title={t("vatRate")}
                    width={100}
                />
                <NFIntInput title={t("vatAmount")} fieldName="vatAmount" />
                <NFIntInput
                    title={t("amountWithVat")}
                    fieldName="amountWithVat"
                />
                <NFLookupConstructionObject
                    title={t("ConstructionObject")}
                    fieldName="constructionObjectId"
                />
            </NFormTable>
        </>
    );
};
